
import DownloadItem from './DownloadItem';

const DownloadCategory = ({ category }) => {
    return (
        <div className="mb-12">
            <h2 className="text-3xl text-secondary font-bold mb-6">{category.nome}</h2>
            <div className="bg-white rounded-lg shadow-lg p-6">
                <div className="grid grid-cols-12 mb-4 text-sm font-medium text-gray-500">
                    <div className="col-span-7 uppercase">Arquivo</div>
                    <div className="col-span-3 sm:col-span-2 text-center uppercase">
                        Data <span className="max-sm:hidden">Atualização</span>
                    </div>
                    <div className="col-span-2 sm:col-span-3 text-center uppercase">
                        <span className="max-sm:hidden">Ação</span>
                        <span className="sm:hidden">-</span>
                    </div>
                </div>

                {category.downloads && category.downloads.map((item) => <DownloadItem key={item.id} item={item} />)}
            </div>
        </div>
    );
};

export default DownloadCategory;
